import React, { useRef } from 'react';
import {
  Form, Button, ListGroup, InputGroup,
} from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

function InclusionExclusionEditor({
  items, onChange, label, placeholder, defaultOptions,
}) {
  const typeaheadRef = useRef(null);

  // Suggestions: defaults that are NOT already in the items list
  const suggestions = (defaultOptions || []).filter((opt) => !items.includes(opt));

  const handleAdd = (selected) => {
    if (!selected || selected.length === 0) return;
    const value = typeof selected[0] === 'string' ? selected[0] : selected[0].label;
    if (value && !items.includes(value)) {
      onChange([...items, value]);
    }
    if (typeaheadRef.current) {
      typeaheadRef.current.clear();
    }
  };

  const handleRemove = (index) => {
    const updated = items.filter((_, i) => i !== index);
    onChange(updated);
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold">{label}</Form.Label>

      {items.length > 0 && (
        <ListGroup variant="flush" className="mb-2" style={{ border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
          {items.map((item, index) => (
            <ListGroup.Item
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className="d-flex align-items-center py-1 px-2"
              style={{ fontSize: '0.9rem' }}
            >
              <span className="flex-grow-1">{item}</span>
              <Button
                variant="link"
                size="sm"
                className="p-0 text-muted"
                onClick={() => handleRemove(index)}
                title="Remove"
              >
                <i className="fa fa-times" />
              </Button>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}

      <InputGroup size="sm">
        <Typeahead
          id={`typeahead-add-${label}`}
          ref={typeaheadRef}
          allowNew
          newSelectionPrefix="Add: "
          options={suggestions}
          onChange={handleAdd}
          placeholder={placeholder || 'Type to add...'}
          size="sm"
        />
      </InputGroup>
    </Form.Group>
  );
}

export default InclusionExclusionEditor;
